/*
 * @Description:
 * @Version: 2.0
 * @Autor: lijunyan
 * @Date: 2021-04-12 10:48:44
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2022-04-05 20:09:02
 */
/**
 * @Author: WeiZisen
 * @Date: 2020-11-06 13:53:14
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-06-04 10:11:02
 * @Description: 请输入一段描述
 * @FilePath: \Design_Vue_pmp\src\utils\request.js
 */
import axios from 'axios'
import Vue from 'vue'
import { Message, Loading } from 'element-ui'
import store from '@/store'
import { getAccessToken } from '@/utils/accessToken'
import { fileServer } from '@/utils/index'
// let loadingInstance
/**
 * @创建axios实例
 */

const service = axios.create({
  // release
  baseURL: fileServer,
  timeout: 500000, // request timeout  // @ 设置超时时间
})
//@请求拦截
service.interceptors.request.use(
  (config) => {
    //@如果vuex中有token的话 直接添加到请求头中
    if (config.httpRequset) {
      config.baseURL = config.httpRequset
    }
    if (getAccessToken()) {
      config.headers['Authorization'] = /* 'Bearer ' +*/ getAccessToken()
      // config.headers['tp_token'] = getAccessToken()
    }
    // loadingInstance = Loading.service({ fullscreen: true, text: '请耐心等待哦' })
    //@如果没有直接返回基础配置
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

//@ 响应拦截
service.interceptors.response.use(
  (response) => {
    const res = response.data

    if (response.headers['content-type'] === 'application/octet-stream') {
      return res
    }
    //@ 响应结果中如果状态码不是200则抛出接口中的信息
    if (res.statusCode !== 200 && res.statusCode != 201 && res.statusCode != 204) {
      Message({
        message: res.result || 'Error',
        type: 'error',
        duration: 2 * 1000,
      })
      Promise.reject(res)
      // return res // Promise.reject(res)
    } else {
      return res
    }
  },
  (error) => {
    Message({
      message: error,
      type: 'error',
      duration: 7 * 1000,
    })

    return Promise.reject(error)
  }
)

export default service
